import React, {useState} from "react";
import serviceProjectApi from "../../../api/service";
import {Edit2} from "react-feather";
import {Button, Modal} from "react-bootstrap";
import {Form as FormikForm, FormField, SubmitButton} from "../../../components/forms";
import * as Yup from "yup";
import notyf from "../../../utils/notyfApi";

/**
 * Represents a modal component used for editing RDP service details.
 * @param {Object} props - The component properties.
 * @param {number} props.id - The ID of the service.
 * @param {Object} props.exists - The existing service details.
 * @param {Function} props.reload - Function to reload the service details.
 * @return {JSX.Element} The RDP service detail modal.
 */
const ServiceDetailRDPModal = ({id, exists, reload}) => {
    const [show, setShow] = useState(false);
    const handleSubmit = async (values, {setSubmitting}) => {
        setSubmitting(false);
        const res = await serviceProjectApi.editServiceProject(id, {...exists, ...values})
        if (!res.ok) return notyf.error("Error " + res.status)
        reload()
        setShow(false)
    }
    return (
        <>
            <Edit2 className={"float-end cursor-pointer"} onClick={() => setShow(!show)}/>
            <Modal show={show} onHide={() => setShow(!show)}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        RDP
                    </Modal.Title>
                </Modal.Header><FormikForm
                initialValues={{
                    service_project_rdp_ip: exists?.service_project_rdp_ip || "",
                    service_project_rdp_username: exists?.service_project_rdp_username || "",
                    service_project_rdp_password: exists?.service_project_rdp_password || "",
                    service_project_rdp_comment: exists?.service_project_rdp_comment || "",
                }}

                // Hier is het validatieschema van alle velden
                validationSchema={Yup.object({
                    service_project_rdp_ip: Yup.string().required('IP moet ingevuld worden'),
                    service_project_rdp_username: Yup.string().required('Gebruikersnaam moet ingevuld worden'),
                    service_project_rdp_password: Yup.string().required('Wachtwoord moet ingevuld worden'),
                    service_project_ip_controller_software_version: Yup.string(),
                })}
                onSubmit={handleSubmit}
            >
                <Modal.Body>
                    <FormField name={"service_project_rdp_ip"}
                               label={"IP"}
                               width={"100%"}
                               placeholder="Vul hier het IP adres in"
                               className={"mb-3"}
                               control={"input"}
                    />
                    <FormField name={"service_project_rdp_username"}
                               label={"Gebruikersnaam"}
                               width={"100%"}
                               placeholder={"Vul hier de gebruikersnaam in"}
                               className={"mb-3"}
                               control={"input"}
                    />
                    <FormField name={"service_project_rdp_password"}
                               label={"Wachtwoord"}
                               width={"100%"}
                               placeholder={"Vul hier het wachtwoord in"}
                               className={"mb-3"}
                               control={"input"}
                    />
                    <FormField name={"service_project_ip_controller_software_version"}
                               label={"Opmerking"}
                               width={"100%"}
                               placeholder={"Vul hier eventueel een opmerking in"}
                               className={"mb-3"}
                               control={"input"}
                               as={"textarea"}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={() => setShow(false)}>
                        Annuleren
                    </Button>
                    <SubmitButton title={"Opslaan"} variant="primary"/>
                </Modal.Footer>
            </FormikForm>
            </Modal>
        </>
    )
}

export default ServiceDetailRDPModal;